module.exports = __webpack_public_path__ + "static/media/YF84_11.8537e628.jpg";